import { IAddSubscriptionPlans, IAddSubscriptionResponse } from "../../utils/types";
import { apiManager } from "../api-manager";

export const addSubscriptionPlan = async (body: IAddSubscriptionPlans) => {
  const res = await apiManager.post<IAddSubscriptionResponse>(
    "subscription-plan/admin/add",
    body
  );
  return res;
};
